export default "__VITE_ASSET__C8Yrv2iu__ 584w";